<template>
    <div class="container-fluid">

          <!-- Page Heading -->
          <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Reports</h1>
          </div>

          <!-- Content Row -->
          <div class="row">
            <div class="col-md-10 mx-auto">
                <div class="card mb-4">
                    <div class="card-header py-3">
                      <h6 class="m-0 font-weight-bold text-primary">Search Calls</h6>
                    </div>
                    <div class="card-body">
                        <form>
                            <div class="row">
                                <div class="col-md-2">
                                    <label for="fromNumber">Phone number: </label>
                                </div>

                                <div class="col-md-4">
                                    <input type="text" class="form-control" id="fromNumber" v-model="form.from_number">
                                </div>

                                <div class="col-md-2">
                                    <label for="toNumber">Call type: </label>
                                </div>

                                <div class="col-md-4">
                                    <select class="custom-select w-100" id="callType" v-model="form.call_type">
                                      <option value="">All</option>
                                      <option value="inbound">Inbound</option>
                                      <option value="outbound">Outbound</option>
                                      <option value="internal">Internal</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="row pt-3">
                                <div class="col-md-2 pr-0">
                                    <label>Executed between:</label>
                                </div>

                                <div class="col-md-4">
                                    <datetime type="datetime" v-model="form.from_date" format="dd-LLL-yy, HH:mm"></datetime>
                                </div>

                                <div class="col-md-2">
                                    <label>and:</label>
                                </div>

                                <div class="col-md-4">
                                    <datetime type="datetime" v-model="form.to_date" format="dd-LLL-yy, HH:mm"></datetime>
                                </div>
                            </div>
                            
                            <div class="row pt-3">
                                <div class="col-md-2">
                                    <label for="user">User:</label>
                                </div>

                                <div class="col-md-10">
                                    <select class="custom-select w-100" id="user" v-model="form.agent">
                                        <option value="">All</option>
                                        <option :value="user.id" v-for="user in users" :key="user.id">{{ user.name }}</option>
                                      </select>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-2 ml-auto">
                                    <button class="btn btn-primary btn-lg btn-block mt-4" type="submit" @click.prevent="searchCalls(0)">Search</button>
                                </div>
                                <div class="col-md-2 mr-auto">
                                    <button class="btn btn-secondary btn-lg btn-block mt-4" type="reset" @click="resetForm">Reset</button>
                                </div>
                            </div>
                          </form>
                    </div>
                  </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-10 text-center py-5 mx-auto" v-if="total == 0 && searchStatus == status.LOADED">
              <div class="alert alert-danger" role="alert">No results found</div>
            </div>
            <div class="col-md-12 pt-4 d-flex" v-if="total > 0 && searchStatus == status.LOADED">
              <div class="form-inline mb-3">
                <div class="form-group">
                  <label class="pr-2">Results per page: </label>
                  <select v-model="form.size" type="number" class="custom-select" @change="changeSize()">
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                    <option value="250">250</option>
                    <option value="0">All</option>
                  </select>
                </div>
              </div>
              <p class="text-primary font-weight-bold ml-3 mt-1 pt-1">Showing results {{ form.page * form.size + 1 }} - {{ form.page * form.size + tableRows.length }} of {{ total }}</p>
            </div>
            <div class="col-md-12 table-responsive" v-if="tableRows.length > 0 && searchStatus == status.LOADED">
                <table class="table table-bordered table-striped table-hover table-sm">
                  <thead>
                    <tr>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('d')">
                          Date 
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='d'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('dr')">
                          Duration 
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='dr'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('t')">
                          Type
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='t'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('fn')">
                          From
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='fn'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('tn')">
                          To
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='tn'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('u')">
                          User
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='u'" />
                        </a>
                      </th>
                      <th scope="col">
                        <a href="#" @click.prevent="sortCalls('s')">
                          Status
                          <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='s'" />
                        </a>
                      </th>
                      <th scope="col">
                        Recording
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in tableRows" :key="row.id">
                      <td>{{ row.date }}</td>
                      <td>{{ row.duration }}</td>
                      <td>{{ row.type}}</td>
                      <td>{{ row.from }} <contact-card :number="row.from" v-if="system && system.crmEnabled && row.type == 'inbound' && row.from.length > 0 && row.from[0] == '+'"></contact-card></td>
                      <td>{{ row.to }} <contact-card :number="row.to" v-if="system && system.crmEnabled && row.type == 'outbound' && row.to.length > 0 && row.to[0] == '+'"></contact-card></td>
                      <td>{{ row.user }}</td>
                      <td>{{ row.status }}</td>
                      <td><span v-html="row.recording"></span></td>
                    </tr>
                  </tbody>
                </table>
                <nav>
                  <ul class="pagination justify-content-end">
                    <li class="page-item" v-if="form.page > 0"><a class="page-link" href="#" @click.prevent="searchCalls(form.page-1)">Previous</a></li>
                    <li class="page-item" v-if="has_more"><a class="page-link" href="#" @click.prevent="searchCalls(form.page+1)">Next</a></li>
                  </ul>
                </nav>
            </div>
            <div class="col-md-12 text-center" v-if="searchStatus == status.LOADING">
              <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <!-- /.container-fluid -->
</template>

<script>
import ContactCard from "../components/ContactCard"
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { mapGetters } from "vuex";

export default {
  name: "Reports",
  created() {
    this.form = this.initialForm();
  },
  data: () => ({
    status: {
      LOADED: 'LOADED',
      LOADING: 'LOADING'
    },
    searchStatus: 'INIT',
    form: {},
    total: 0,
    tableRows: [],
    has_more: false,
  }),
  computed: {
      ...mapGetters([
          'error',
          'system'
      ]),
      users() {
        if (!this.system || !this.system.agents) {
          return []
        }

        return [...this.system.agents].sort((a,b) => a.name.localeCompare(b.name));
      },
  },
  methods: {
    initialForm() {
      return {
        from_number: '',
        from_date: '',
        to_date: '',
        call_type: '',
        agent: '',
        page: 0,
        size: 50,
        order_by: 'd',
        order_desc: true,
      }
    },
    resetForm() {
      this.form = this.initialForm();
      this.searchStatus = 'INIT';
    },
    changeSize() {
      this.searchCalls(0);
    },
    formatDate(d) {
      let date = d.split(',')

      let [day, month, year] = date[0].split(' ')

      date[0] = [day, month, year].join('-')
      
      return date.join(',')
    },
    sortCalls(field) {
      if (field == this.form.order_by) {
        this.form.order_desc = !this.form.order_desc;
      } else {
        this.form.order_by = field;
        this.form.order_desc = true;
      }
      this.searchCalls(0);
    },
    formatDuration(d) {
      //We use Math.floor becouse we are dealing with amounts greater than 0
      let h = Math.floor( d / 3600);
      let m = Math.floor(( d % 3600) / 60);
      let s = d - h * 3600 - m * 60;

      let hours = h >= 10 ? h : ('0' + h);
      let minutes = m >= 10 ? m : ('0' + m);
      let seconds = s >= 10 ? s : ('0' + s);

      return `${hours}:${minutes}:${seconds}`;
    },
    async searchCalls(page) {
      this.searchStatus = 'LOADING'
      let calls = [];
      this.has_more = false

      let prevPage = this.form.page
      this.form.page = page

      let result = await this.$store.dispatch('searchCalls', this.form)

      if (!this.error) {
        this.total = result.data.total;
        this.has_more = result.data.has_more

        const dateFormatOptions = {
          'day': '2-digit',
          'month': 'short',
          'year': '2-digit',
          'hour': '2-digit',
          'minute': '2-digit',
          'second': '2-digit',
        }

        let dateFormat = new Intl.DateTimeFormat('en-gb', dateFormatOptions)

        result.data.results.forEach(call => {
          let date = 'Unknown';

          if (call.start > 0) {
            let d = new Date();
            d.setTime(call.start*1000);
            date = this.formatDate(dateFormat.format(d));
          }

          let id = call.record_sid ? call.record_sid : call.id;

          let duration = call.end - call.start

          calls.push({
            id: id,
            date: date,
            type: call.direction,
            from: call.from,
            to: call.to,
            user: call.agent,
            status: call.result,
            recording: call.record_url ? `<audio controls><source src="${call.record_url}.mp3" type="audio/mpeg"></audio>` : '',
            duration: this.formatDuration(duration)
          })
        });
      }
      else {
        this.form.page = prevPage;
        alert(this.error)
      }
      this.tableRows = calls;
      this.searchStatus = 'LOADED';
    },
  },
  components: {
    'contact-card': ContactCard,
    'datetime': Datetime,
  },
};
</script>

<style scoped>
::v-deep .svg-inline--fa {
  margin-right: 0px !important;
}

::v-deep div.material-table {
  padding: 16px !important;
}

::v-deep table th, table td {
    padding: 12px!important;
}

::v-deep table td {
    padding: 12px!important;
}

::v-deep .table-hover tbody tr:hover {
  background-color: #fceec9 !important;
  color: #858796;
}

::v-deep .table-hover tbody tr:active {
  background-color: #b8daff !important;
  color: #858796;
}

::v-deep tbody tr td div {
  font-size: 16px !important;
}

::v-deep thead tr th {
  font-size: 16px !important;
}

::v-deep .table-header {
  display: none;
}

::v-deep .table-header .actions {
  display: none;
}

::v-deep .material-pagination {
  list-style: none !important;
  padding-top: 8px !important;
  padding-left: 20px !important;
}

::v-deep .datatable-length label {
  margin-bottom: 0px !important;
}

::v-deep  .btn.focus, .btn:focus {
    box-shadow: none!important;
}

::v-deep table {
  width: 100%;
}

::v-deep table th:last-child {
  width: 320px!important;
}
</style>